// extracted by mini-css-extract-plugin
export default {"custom_table_container":"index_custom_table_container__96AyK","empty_state_text":"index_empty_state_text__1muoN","no_data":"index_no_data__w2ri7"};